import { Box, Stack } from '@mui/material'
import { DynamicFlowStepper, DynamicFlowView, useDynamicFlowController } from 'components/common/DynamicFlow'
import React, { useEffect, useMemo } from 'react'

import { MUIButton } from 'components/common/MUIButton'
import Modal from 'components/common/Modals/Modal/Modal'
import { UploadOptionsStep } from './UploadOptionsStep.component'
import { UploadVisualsStep } from './UploadVisualsStep.component'
import { useClientGallery } from 'components/pages/Gallery/_main/ClientGallery/_main'
import { useTranslation } from 'react-i18next'

/** Enum of all upload visuals steps */
export enum UploadVisualsStepKey {
  UPLOAD_PHOTOS = 'UPLOAD_PHOTOS',
  OPTIONS = 'OPTIONS',
}

/**
 * @component ClientPropertySelfUploadPopupController 
 * @example
 * <ClientPropertySelfUploadPopupController />
 */

export const ClientPropertySelfUploadPopupController: React.FC = () => {

  const { t } = useTranslation(['self_upload_popup', 'common'])
  const flowCtrl = useDynamicFlowController()

  const isLastStep = useMemo(() => !flowCtrl.currentNode?.next, [flowCtrl.currentNode?.next])

  const {
    isUploadPopupOpened,
    setIsUploadPopupOpened
  } = useClientGallery()

  const onClose = () => {
    setIsUploadPopupOpened(false)
    flowCtrl.setHead(UploadVisualsStepKey.UPLOAD_PHOTOS)
  }

  useEffect(() => {
    flowCtrl.createEntryNode(
      UploadVisualsStepKey.UPLOAD_PHOTOS,
      {
        component: <UploadVisualsStep />,
        hasFooter: true,
        type: 'main',
      }
    )

    flowCtrl.insertAfter(
      UploadVisualsStepKey.UPLOAD_PHOTOS,
      UploadVisualsStepKey.OPTIONS,
      {
        component: <UploadOptionsStep />,
        hasFooter: true,
        type: 'main',
      }
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Modal
      isOpen={isUploadPopupOpened}
      onClose={onClose}
      onClickOutside={onClose}
      hasHeaderContentDivider
      contentStyle={{
        width: '80rem'
      }}
      extraHeaderContent={
        <Box width="50%">
          <DynamicFlowStepper stepNameTranslatorFnc={(key) => t(`steps.${key}`)} />
        </Box>
      }
      footerContent={
        <Stack direction="row" justifyContent="flex-end" gap={2}>

          <MUIButton type="secondaryBorder" onClick={onClose}>
            {t('Cancel')}
          </MUIButton>

          {!!flowCtrl.currentNode?.prev &&
            <MUIButton
              type="secondaryBorder"
              onClick={() => { flowCtrl.setHead(flowCtrl.currentNode!.prev!) }}
            >
              {t('common:Previous')}
            </MUIButton>
          }

          {flowCtrl.currentNode?.key === UploadVisualsStepKey.UPLOAD_PHOTOS &&
            <MUIButton
              onClick={() => {
                // TODO: add validation with upload visuals
                flowCtrl.setHead(flowCtrl.currentNode!.next!)
              }}
            >
              {t('next_step')}
            </MUIButton>
          }

          {isLastStep &&
            <MUIButton
              onClick={() => { }}
            >
              {t('upload_photos')}
            </MUIButton>
          }

        </Stack>
      }
    >
      <Stack
        justifyContent="flex-start"
        width="100%"
        height="100%"
        overflow="auto"
        position="relative"
      >
        <Stack gap={2}>
          <DynamicFlowView />
        </Stack>
      </Stack>
    </Modal>
  )
}
